import { ModuleProps } from '@/components/TabModules/Module'
import { useSearchParams } from 'react-router-dom'

interface useTabModulesProps {
    modules: ModuleProps[]
    clearFilters?: boolean
    hideActiveTab?: boolean
}

const useTabModules = ({
    modules,
    clearFilters = false,
    hideActiveTab = true,
}: useTabModulesProps) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const activeTab = searchParams?.get('tab') || modules?.[0]?.value

    const setActiveTab = (newTab: string) => {
        setSearchParams((prev) => {
            prev.set('tab', newTab)
            if (clearFilters) prev.delete('filters')
            return prev
        })
    }

    const TabModuleComponent = modules?.find(
        (tab) => tab.value === activeTab
    )?.component
    // Tab props for any tab navigation component
    const TabProps = {
        modules: modules?.filter((item) =>
            hideActiveTab ? item.value !== activeTab : true
        ),
        activeTab: activeTab,
        onChangeTab: setActiveTab,
        className: 'text-bg-primary',
        tabClassName: '!text-bg-primary uppercase',
    }

    return {
        TabProps,
        TabModuleComponent,
        activeTab,
    }
}

export default useTabModules
